import { Button } from "semantic-ui-react";
import React from "react";

import "./styles.scss";

interface SimpleStepperProps {
  index: number;
  total: number;
  onUpdate: (index: number) => void;
}

export const SimpleStepper: React.FC<SimpleStepperProps> = ({ index, total, onUpdate }) => {
  return (
    <div className={"simpleStepper"}>
      <Button
        icon={"left arrow"}
        basic
        circular
        disabled={index == 0}
        onClick={e => {
          onUpdate(Math.max(index - 1, 0));
          e.preventDefault();
        }}
        size={"mini"}
      />
      <span className={"stepperText"}>
        {index + 1} of {total}
      </span>
      <Button
        icon={"right arrow"}
        basic
        circular
        disabled={index == total - 1}
        onClick={e => {
          onUpdate(Math.min(index + 1, total - 1));
          e.preventDefault();
        }}
        size={"mini"}
      />
    </div>
  );
};
